export default __webpack_public_path__ + "static/social-homicidios-mujeres_en-61e4a4100b05cc49befe70ca54ce735a.png";